const DivisionLine = ({ color }) => (
  <hr
    style={{
      color: color,
      backgroundColor: color,
      height: 0.5,
      width: 'inherit',
      marginTop: '3%'
    }}
  />
);

export default DivisionLine;
